/**
 * Items del menú principal, en un solo sitio.
 *
 * Antes estaban duplicados literalmente en el menú de escritorio y en el móvil
 * de `MainMenu.tsx`: un enlace nuevo había que añadirlo dos veces y las dos
 * copias podían divergir (de hecho el menú móvil marcaba "Inicio" con
 * `/home`, una ruta que no existe).
 */

export type MainMenuItem = {
  /** clave de React del item */
  key: string
  /** texto visible */
  label: string
  /** ruta de destino */
  to: string
  /** prefijo con el que el item se marca como activo */
  match: string
  /** true cuando el item solo está activo con coincidencia exacta (la portada) */
  exact?: boolean
  /** id que el CSS usa para el icono del item */
  id?: string
}

export const DATABASE_PATH =
  '/bdd/clima/emisiones-de-gases-de-efecto-invernadero/totales-brutas'

export const HOME_ITEM: MainMenuItem = {
  key: 'home',
  label: 'Inicio',
  to: '/',
  match: '/',
  exact: true,
}

export const ATLAS_ITEM: MainMenuItem = {
  key: 'atlas',
  label: 'Atlas Energía',
  to: '/atlas',
  match: '/atlas',
  id: 'atlas',
}

const HEAD_ITEMS: MainMenuItem[] = [
  { key: 'observatory', label: 'El observatorio', to: '/observatorio', match: '/observatorio' },
  { key: 'climate-action', label: 'Acción climática', to: '/accionclima', match: '/accionclima' },
  { key: 'database', label: 'Base de datos', to: DATABASE_PATH, match: '/bdd', id: 'bdd' },
]

const TAIL_ITEMS: MainMenuItem[] = [
  { key: 'overview', label: 'De un vistazo', to: '/transicion', match: '/transicion' },
  { key: 'resources', label: 'Recursos', to: '/recursos', match: '/recursos' },
  { key: 'news', label: 'Noticias', to: '/noticias', match: '/noticias' },
]

/** El Atlas solo aparece si la instalación lo tiene habilitado. */
export const getMainMenuItems = (showAtlas: boolean): MainMenuItem[] => [
  HOME_ITEM,
  ...HEAD_ITEMS,
  ...(showAtlas ? [ATLAS_ITEM] : []),
  ...TAIL_ITEMS,
]

/**
 * Un item está activo si la ruta actual es exactamente la suya (portada) o
 * cuelga de ella (`/bdd/...` activa "Base de datos", pero `/bddfalsa` no).
 */
export const isItemActive = (item: MainMenuItem, pathname: string): boolean =>
  item.exact
    ? pathname === item.match
    : pathname === item.match || pathname.indexOf(`${item.match}/`) === 0
